import React, { createContext, useContext } from "react";
import { Toaster as Sonner } from "../components/ui/sonner";

type ToastProviderProps = {
  children: React.ReactNode;
};

const ToastContext = createContext<null>(null);

export function ToastProvider({ children }: ToastProviderProps) {
  return (
    <ToastContext.Provider value={null}>
      <Sonner 
        className="toaster group" 
        toastOptions={{
          classNames: {
            toast: "group toast group-[.toaster]:bg-white group-[.toaster]:text-brand-primary group-[.toaster]:border-brand-primary/20 group-[.toaster]:shadow-lg",
            description: "group-[.toast]:text-brand-primary/70",
            actionButton: "group-[.toast]:bg-[#967F81] group-[.toast]:text-white group-[.toast]:font-medium",
            cancelButton: "group-[.toast]:bg-[#967F81]/10 group-[.toast]:text-brand-primary",
            success: "group-[.toast]:!bg-white group-[.toast]:border-brand-primary/20 group-[.toast]:text-brand-primary",
            successIcon: "group-[.toast]:!bg-[#967F81] group-[.toast]:text-white",
            title: "group-[.toast]:text-brand-primary",
            successIconSVG: "group-[.toast]:fill-[brand-primary] group-[.toast]:text-brand-primary"
          },
        }}
      />
      {children}
    </ToastContext.Provider>
  );
}

export const useToast = () => {
  const context = useContext(ToastContext);

  if (context === undefined) {
    throw new Error("useToast must be used within a ToastProvider");
  }

  return context;
}; 